/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Registration event form validation helpers for EventCreation page.
 * @module utils/eventCreation/eventCreationValidation
 */

export const isAudienciaSociosChecked = (audiencia) =>
  audiencia === 0 ||
  audiencia === "0" ||
  audiencia === 2 ||
  audiencia === "2";

export const isAudienciaNoSociosChecked = (audiencia) =>
  audiencia === 1 ||
  audiencia === "1" ||
  audiencia === 2 ||
  audiencia === "2";

export const getEventFieldBorderColor = (showError, hasValue) =>
  showError && !hasValue ? "red" : "#909092";

export const isAudienciaChosen = (audiencia) =>
  audiencia === 0 ||
  audiencia === 1 ||
  audiencia === 2 ||
  audiencia === "0" ||
  audiencia === "1" ||
  audiencia === "2";

export const isCostFilled = (costo) => {
  if (costo === null || costo === undefined) {
    return false;
  }

  const normalizedCost = String(costo).trim();
  if (normalizedCost === "") {
    return false;
  }

  const parsedCost = Number(normalizedCost);
  return Number.isFinite(parsedCost) && parsedCost >= 0;
};

export const isEventCreationSaveDisabled = ({
  hasChanges,
  loading,
  saving,
  formData,
}) =>
  !hasChanges ||
  loading ||
  saving ||
  !formData.nombre ||
  !formData.fechaEvento ||
  !isAudienciaChosen(formData.audiencia) ||
  !isCostFilled(formData.costoSocios) ||
  !isCostFilled(formData.costoNoSocios) ||
  !formData.hora ||
  !formData.duracion ||
  !formData.descripcion ||
  !formData.imagenBanner ||
  !formData.fechaDisponibleSocios ||
  !formData.fechaDisponibleNoSocios ||
  !formData.fechaLimiteRegistro ||
  !formData.ubicacion ||
  !formData.cupoMaximo;

export const toggleEventAudiencia = (currentAudiencia, which) => {
  const sociosWas =
    currentAudiencia === 0 ||
    currentAudiencia === "0" ||
    currentAudiencia === 2 ||
    currentAudiencia === "2";
  const noSociosWas =
    currentAudiencia === 1 ||
    currentAudiencia === "1" ||
    currentAudiencia === 2 ||
    currentAudiencia === "2";
  const socios = which === "socios" ? !sociosWas : sociosWas;
  const noSocios = which === "noSocios" ? !noSociosWas : noSociosWas;

  if (socios && noSocios) {
    return 2;
  }
  if (socios) {
    return 0;
  }
  if (noSocios) {
    return 1;
  }
  return null;
};
